import { useMutation } from '@tanstack/react-query';
import useAxios from '../../../app/hooks/useAxios';
import queryClient from '../../../app/utils/queryClient';

const useUserUpdateWelcomed = () => {
	const { post } = useAxios();

	const userUpdateWelcomed = () => {
		return post(`/users/me/welcomed`, null);
	};

	return useMutation(userUpdateWelcomed, {
		onSuccess: () => {
			queryClient.invalidateQueries({ predicate: (query) => query.queryKey[0] === 'userProfile' });
		},
	});
};

export default useUserUpdateWelcomed;
